import NProgress from 'nprogress'

let loadingCount = 0

export const startLoading = () => {
  if (loadingCount === 0) {
    NProgress.start()
  }
  loadingCount = loadingCount + 1
}

export const doneLoading = () => {
  loadingCount = loadingCount - 1
  if (loadingCount <= 0) {
    NProgress.done()
    loadingCount = 0
  } else {
    NProgress.set(1 / (loadingCount * 3 + 1))
  }
}
